import styled from "@emotion/styled";

export const ContainerHeaderFilter = styled.div`
  flex-basis: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 0px) and (max-width: 425px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 20px;
  }
`;

export const PagginationSelect = styled.div`
  position: absolute;
  right: 0%;
  top: 10%;
  padding-right: 10px;
`;
